<!-- 关于企业出海 -->
<template>
  <div class="SalesRampaign fd_column">
    <div class="m-b-30">
      <div class="title_mid">
        <img src="@/assets/home/events.png" alt="" />
        <div @click="toRouterPush('/Events')" class="more">
          <div>VIEW MORE</div>
          <img src="@/assets/home/arrow-right-up-line.png" alt="" />
        </div>
      </div>
    </div>
    <div class="component_box">
      <div
        v-for="item in listData"
        :key="item.id"
        :style="{ backgroundImage: 'url(' + $baseImgUrl + item.headImg + ')' }"
        class="itembox"
        @click="linkJump(1, '/EventsDetail', { id: item.id })"
      >
        <img class="start-img" src="@/assets/home/Recommend.png" alt="" />
        <div
          :style="{
            '--bg-image':
              'url(' +
              (windowWidth > 1024 ? businessTypeNameBg : businessTypeNameMBg) +
              ')',
            '--bg-color': item.theValue,
          }"
          class="businessTypeImg"
        >
          {{ item.businessTypeName }}
        </div>
        <div class="shade"></div>
        <div class="content_box">
          <div class="conter">{{ item.activityName }}</div>
          <div class="loca_fd">
            <div class="loca">
              <img src="@/assets/home/active-Vector.png" alt="" />
              <div>{{ item.activityPlace }}</div>
            </div>
            <div class="time">
              <!-- {{ item.activityDateStart }}/{{ item.activityDateEnd }} -->
              <div class="Upcoming" v-if="item.status == 0">Upcoming</div>
              <div class="Ongoing" v-if="item.status == 1">Ongoing</div>
              <div class="Ended" v-if="item.status == 2">Ended</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { eventsgetList } from "@/api/Home/Home";
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      listData: [],
      businessTypeNameBg: require("@/assets/showcases/Rectangle.png"),
      businessTypeNameMBg: require("@/assets/showcases/RectangleM.png"),
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    async getList() {
      const res = await eventsgetList();
      if (res.code === 1) {
        this.listData = res.data;
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
@import "~@/static/styles/variables.less";
@import "~@/static/styles/index.less";
</style>

<style lang="less" scoped>
@media screen and (min-width: 750px) {
  @import "./SalesRampaignPC.less";
}
@media screen and (max-width: 750px) {
  @import "./SalesRampaignM.less";
}
</style>
